(() => {
  const TARGET = ".bogos-volume-discount-widget-title";
  const FROM_TEXT = "Volume discount save";
  const TO_TEXT = "Case Quantity Discount";
  const MARK = "data-case-discount-patched";

  let rafId = null;
  let disconnectTimer = null;

  function patchAll() {
    let patchedAny = false;
    const nodes = document.querySelectorAll(TARGET);
    nodes.forEach((el) => {
      if (!el.hasAttribute(MARK) && el.textContent && el.textContent.includes(FROM_TEXT)) {
        el.textContent = TO_TEXT;
        el.setAttribute(MARK, "1");
        patchedAny = true;
      }
    });
    return patchedAny;
  }

  // Try immediately in case elements already exist
  patchAll();

  const observer = new MutationObserver(() => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      if (patchAll()) {
        // Keep watching a little longer after changes (handles re-renders)
        if (disconnectTimer) clearTimeout(disconnectTimer);
        disconnectTimer = setTimeout(() => observer.disconnect(), 8000);
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Small safety net: short polling to catch odd injection patterns
  let tries = 0;
  const poll = setInterval(() => {
    if (patchAll() || ++tries > 10) clearInterval(poll);
  }, 150);
})();
